import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';


@Component({
  selector: 'lib-responsive-preview-selector',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './responsive-preview-selector.component.html',
  styleUrl: './responsive-preview-selector.component.scss'
})
export class ResponsivePreviewSelectorComponent {
  @Output() selectedDeviceChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() resetBreakpoint: EventEmitter<string> = new EventEmitter<string>();
  
  // Input properties for modified indicators
  @Input() mobileModified = false;
  @Input() tabletModified = false;
  @Input() desktopModified = false;
  
  selectedDevice = "desktop";

  
  protected SelectDevice(device: string): void {
    this.selectedDevice = device;
    this.selectedDeviceChange.emit(device);
  }

  protected ResetBreakpoint(event: Event, device: string): void {
    event.preventDefault();
    event.stopPropagation();
    this.resetBreakpoint.emit(device);
  }
}
